export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import WalkInRegistration from "./WalkInRegistration";

createRoot(document.getElementById("tmt-walk-in-registration")).render(
  <StrictMode>
    <WalkInRegistration />
  </StrictMode>
);
